import React from 'react'

const SlideOverBody = (props) => {
    return (
        <div className="relative p-6 flex-1 overflow-y-auto transition-opacity duration-200">
            {props.children}
        </div>
    )
}

export default SlideOverBody